module.exports = __webpack_public_path__ + "img/40_69_008_980.67f832bf.jpg";